<template>
    <v-card
        style="min-height: 100%; max-height: 779px"
        :disabled="loading"
        class="d-flex flex-column justify-space-between"
    >
        <v-card-title class="px-7 py-4 d-flex justify-space-between">
            <p class="text-title-medium" style="font-size: 1.25rem">
                Web inputs
            </p>
            <div>
                <v-btn
                    variant="outlined"
                    rounded
                    class="px-4 mr-4 text-uppercase text-title-small"
                    @click="() => (pythonDialog = true)"
                    color="rgba(0, 0, 0, 0.6)"
                    ><v-icon class="mr-1" size="large">$pythonLogo</v-icon>Call
                    from Python</v-btn
                >
                <v-btn
                    variant="outlined"
                    rounded
                    class="px-4 text-uppercase text-title-small"
                    @click="() => (excelDialog = true)"
                    color="rgba(0, 0, 0, 0.6)"
                    ><v-icon class="mr-1" size="large">$excelLogo</v-icon>Call
                    from Excel</v-btn
                >
            </div>
        </v-card-title>
        <v-card-text
            style="max-height: inherit; overflow-y: hidden; height: 100%"
            class="pb-0 flex-grow-1 flex-shrink-0 d-flex flex-column pt-6"
        >
            <WebInputs
                style="width: 100%"
                :calc="calc"
                :loading="loading"
                :maxHeight="maxHeightButtons"
                @submit="submit"
            />
        </v-card-text>
        <v-card-actions class="py-0 pr-0" style="height: 83px">
            <WebInputsButtons
                class="pr-4"
                v-if="tab === 0"
                :examples="examples"
                :loading="loading"
                :calc="calc"
                @example-selected="exampleSelected"
                @submit="submit"
            />
        </v-card-actions>
        <DialogContainer v-model="excelDialog">
            <template v-slot:title>Calling from Excel</template>
            <ExcelInputs :calc="calc" />
        </DialogContainer>
        <DialogContainer v-model="pythonDialog">
            <template v-slot:title>Calling from Python</template>
            <PythonInputs :calc="calc" />
        </DialogContainer>
    </v-card>
</template>
<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import WebInputs from './calc-inputs/WebInputs.vue'
import ExcelInputs from './calc-inputs/ExcelInputs.vue'
import PythonInputs from './calc-inputs/PythonInputs.vue'
import WebInputsButtons from './calc-inputs/WebInputsButtons.vue'
import DialogContainer from './calc-inputs/DialogContainer.vue'

const store = useStore()
const instance = getCurrentInstance()

const props = defineProps([
    'calc',
    'loading',
    'maxHeightNoButtons',
    'maxHeightButtons',
    'noButtonsPadding',
])
const emit = defineEmits(['submit'])

const tab = ref(0)
const examples = ref([])
const excelDialog = ref(false)
const pythonDialog = ref(false)

onMounted(() => {
    example()
})

function submit() {
    emit('submit')
}

async function example() {
    if (props.calc.calcId) {
        const exs = await store.dispatch('getExamples', {
            calcId: props.calc.calcId,
        })
        examples.value = exs
    }
}

function exampleSelected(example) {
    props.calc.inputs.forEach((i) => (i.value = ''))
    example.inputs.forEach(({ name, value }) => {
        const input = props.calc.inputs.find((i) => i.name === name)
        if (input) {
            if (input.type === 'System.Boolean') {
                input.value =
                    value[0].toUpperCase() + value.slice(1).toLowerCase()
            } else {
                input.value = value
            }
        }
    })

    if (props.calc.inputGroups) {
        props.calc.inputGroups.forEach((ig) => {
            ig.inputs.forEach((i) => {
                const input = example.inputs.find((se) => se.name === i.name)
                if (input) {
                    i.value = input.value
                }
            })
        })
    }

    const posthog = instance?.proxy?.$posthog
    if (posthog && posthog.__loaded) {
        posthog.capture('trialInputsClick', {
            calcName: props.calc.name,
            calcFullname: props.calc.fullname,
            persistentCalcId: props.calc.persistentCalcID,
            exampleTitle: example.title,
        })
    }
}
</script>
